import { Box, Grid, Skeleton, Stack, SvgIcon, Typography, useTheme } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as IconHousekeeping } from '../../../../assets/svg/housekeeping.svg';

type Props = {
    className?: string;
};

export const HousekeepingLoader: FC<Props> = ({ className }) => {
    const { palette, shadows } = useTheme();
    const { t } = useTranslation();

    return (
        <Stack
            alignItems="stretch"
            className={className}
            css={{
                position: 'relative',
                color: 'inherit',
                textDecoration: 'none',
                background: palette.background.default,
                zIndex: 'auto',

                '::after': {
                    content: '""',
                    position: 'absolute',
                    zIndex: -1,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    top: 0,
                    boxShadow: shadows[1],
                },
            }}
            padding={{ xs: '32px 16px', md: '36px' }}
            gap="32px"
        >
            <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Stack
                    direction="row"
                    alignItems="center"
                    gap="16px"
                    css={{
                        textDecoration: 'none',
                        color: palette.common.black,
                    }}
                >
                    <Box>
                        <SvgIcon>
                            <IconHousekeeping css={{ fill: palette.primary.main }} />
                        </SvgIcon>
                    </Box>

                    <Typography variant="h3" flex={1} textTransform="uppercase">
                        {t('housekeeping')}
                    </Typography>
                </Stack>
            </Stack>
            <Grid container gap="24px" justifyContent="space-between">
                <Grid item css={{ width: '96px', height: '96px' }}>
                    <Skeleton variant="rectangular" css={{ width: '96px', height: '96px' }} />
                </Grid>
                <Grid item flexGrow={2}>
                    <Stack gap="4px" justifyContent="space-between" height="100%">
                        <Skeleton />
                        <Skeleton />
                        <Skeleton />
                    </Stack>
                </Grid>
            </Grid>
        </Stack>
    );
};
